(() => {
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (typeof gsap === 'undefined') return;
  if (typeof ScrollTrigger !== 'undefined') gsap.registerPlugin(ScrollTrigger);

  // Hero entrance: stagger the copy elements
  const heroCopy = document.querySelector('.cg-hero__copy');
  if (heroCopy) {
    gsap.from(heroCopy.children, {
      y: 24,
      opacity: 0,
      duration: 0.6,
      ease: 'power2.out',
      stagger: 0.08,
      clearProps: 'all',
    });
  }

  // Scroll reveals for [data-cg-reveal]
  if (typeof ScrollTrigger !== 'undefined') {
    document.querySelectorAll('[data-cg-reveal]').forEach((el) => {
      gsap.from(el, {
        y: 26,
        opacity: 0,
        duration: 0.8,
        ease: 'power2.out',
        clearProps: 'all',
        scrollTrigger: { trigger: el, start: 'top 88%', once: true },
      });
    });

    // Gentle float on category items, only while their stage is on screen.
    // Animate the product IMAGE, not the .cg-cat__item wrapper: the wrapper
    // has a CSS :hover{transform:translateY(-1rem) rotate(-1.5deg)} rule
    // (cg-univers.css), and an inline transform from GSAP on that same
    // element would win over the CSS hover transition, killing the hover
    // lift. Floating the image instead keeps the hover affordance on the
    // parent untouched while still giving the stage a living, ambient feel.
    document.querySelectorAll('.cg-cat__stage').forEach((stage) => {
      const items = [...stage.querySelectorAll('.cg-cat__item')].filter(
        (item) => !item.classList.contains('cg-cat__item--placeholder')
      );
      if (!items.length) return;

      const tweens = items
        .map((item, i) => {
          const img = item.querySelector('.cg-univers__img');
          if (!img) return null;
          return gsap.to(img, {
            y: -8,
            duration: 3,
            ease: 'sine.inOut',
            yoyo: true,
            repeat: -1,
            delay: i * 0.6,
            paused: true,
          });
        })
        .filter(Boolean);

      if (!tweens.length) return;

      ScrollTrigger.create({
        trigger: stage,
        start: 'top bottom',
        end: 'bottom top',
        onToggle: (self) => tweens.forEach((t) => (self.isActive ? t.play() : t.pause())),
      });
    });
  }
})();
